/**
 * Surviving action of the retired structures list: selecting the active plant
 * (site group).
 */
export const SET_PLANT = 'SET_PLANT';
export function setPlant(plantId) {
  return {
    type: SET_PLANT,
    plant: plantId,
  };
}
